/* eslint-disable no-nested-ternary */
import classname from 'classnames';
import React, { memo, useCallback, useEffect } from 'react';
import upperFirst from 'lodash/upperFirst';
import Popup from "./Popup";
import "./index.scss";
const Drawer = ({
  title,
  visible,
  hasMask = true,
  offset = 0,
  className,
  direction = 'bottom',
  children,
  onClose
}) => {
  const closeMask = useCallback(e => {
    e?.stopPropagation?.();
    onClose?.();
  }, [onClose]);
  useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);
  return /*#__PURE__*/React.createElement(Popup, null, /*#__PURE__*/React.createElement("div", {
    className: classname('drawer-container', {
      hide: !visible
    }, className, direction)
  }, /*#__PURE__*/React.createElement("div", {
    className: "drawer-main",
    style: {
      [`padding${upperFirst(direction)}`]: offset
    }
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "drawer-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "drawer-head-txt"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "drawer-head-close"
  }, "\u5B8C\u6210")) : title === null ? null : /*#__PURE__*/React.createElement("div", {
    className: "drawer-bar",
    onTouchMove: closeMask,
    onClick: closeMask
  }), /*#__PURE__*/React.createElement("div", {
    className: "drawer-body"
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: classname('drawer-mask', {
      hasMask,
      visible
    }),
    onClick: closeMask
  })));
};
Drawer.displayName = 'cc-drawer';

/**  */

export default /*#__PURE__*/memo(Drawer);